<template>
  <search-group-form-page
    v-if="search"
    :key="`edit-query-${search_id}-${search.updated_at}`"
    :url="`projects/${project_id}/searches/${search_id}`"
    :resource-name="resourceName"
    :item_id="search_id"
    :item="search"
    :title="$t('booleanSearch.edit_bool_query')"
    :is-busy="isBusy"
  />
</template>

<script>
// Plugins
import { mapActions, mapState } from "vuex";

// Components
import SearchGroupFormPage from "../../components/boolean-search/SearchGroupFormPage.vue";

// Mixins
import notifyMessages from "../../mixins/boolean-search/notifyMessages";

export default {
  name: "edit-query",

  props: {
    search_id: { // prop from $router
      type: String,
      required: true
    }
  },

  mixins: [ notifyMessages ],

  async created() {
    const id = parseInt(this.search_id)
    this.$store.commit('booleanSearch/RESET_SINGLE_RESOURCE', this.resourceName)
    await this.getQuery({url: `projects/${this.project_id}/searches/${id}`, key: this.resourceName}).catch(() => this.notifyStoreError())
  },

  data() {
    return {
      resourceName: 'search',
    }
  },

  computed: {
    ...mapState({
      project_id: state => state.booleanSearch.project_id,
      search: state => state.booleanSearch.search,
    }),
    isBusy() { return this.search.isBusy },
  },

  methods: {
    ...mapActions({
      getQuery: 'booleanSearch/getSingleResource',
    }),
  },

  components: {
    SearchGroupFormPage
  }
}
</script>